import {
  AfterViewInit,
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TeamMember } from '@interfaces/code-team/team-member';
import { InputSearchComponent } from '@shared/components/molecules/input-search/input-search.component';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { NgClass } from '@angular/common';
import { SaveBtn } from '@shared/components/save-btn/save-btn.component';
import { CancelBtn } from '@shared/components/cancel-btn/cancel-btn.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { WeekDay } from '@features/staff-scheduler/staff-scheduler.component';
import { IconsImageComponent } from '../../../../shared/components/icons-image/icons-image.component';

type PickedUser = { id: string; name: string };

@Component({
  standalone: true,
  selector: 'app-shift-scheduler-popover-edit',
  templateUrl: './shift-scheduler-popover-edit.component.html',
  styleUrls: ['./shift-scheduler-popover-edit.component.scss'],
  imports: [
    NgbPopover,
    InputSearchComponent,
    NgClass,
    SaveBtn,
    CancelBtn,
    TranslateModule,
    MatIconModule,
    IconsImageComponent,
  ],
})
export class ShiftSchedulerPopoverEditComponent implements AfterViewInit {
  @Input({ required: true }) users: TeamMember[] = [];
  @Input({ required: true }) weekDay: WeekDay = WeekDay.MONDAY;
  @Input({ required: true }) shiftIndex!: number;
  @Input({ required: true }) parentForm?: FormGroup;
  @Input() placement?: FormGroup;
  @Output() popoverChangeSelection = new EventEmitter<NgbPopover>();
  @ViewChild('p') popover: NgbPopover | undefined;
  private selectedUserIds: string[] = [];
  private search = signal('');
  filteredUsers = computed(() => {
    const searchValue = this.search();
    return this.users.filter((u) =>
      u.name.toLowerCase().includes(searchValue.toLowerCase()),
    );
  });
  private fb = inject(FormBuilder);

  get assignments() {
    return (this.parentForm?.get('shifts') as FormArray)
      .at(this.shiftIndex)
      .get(this.weekDay) as FormArray;
  }

  shifts() {
    return this.parentForm?.get('shifts') as FormArray;
  }

  isAssignmentAdded() {
    return this.assignments.controls.length > 0;
  }

  isSelected(id: string) {
    return this.selectedUserIds.includes(id);
  }

  ngAfterViewInit(): void {
    // this.popover?.shown.asObservable().subscribe(() => {
    //   const userFormArray = this.patients()
    //     .at(this.shiftIndex)
    //     .get(this.weekDay) as FormArray;
    //   this.selectedUserIds = userFormArray.controls.map((u) =>
    //     u.get('id')?.value.includes('@')
    //       ? u.get('id')?.value
    //       : `@${u.get('id')?.value}`,
    //   );
    // });
  }

  handleSearchChange(search: string) {
    this.search.set(search);
  }

  selectUser(user: PickedUser) {
    if (this.selectedUserIds.includes(user.id)) {
      this.selectedUserIds = this.selectedUserIds.filter(
        (id) => id !== user.id,
      );
    } else {
      this.selectedUserIds.push(user.id);
    }
  }

  handleSubmit() {
    const filteredUsers = this.users
      .filter((u) => this.selectedUserIds.includes(u.id))
      .map((u) =>
        this.fb.group({
          id: u.id,
          name: u.name,
          // role: u.role,
        }),
      );

    this.assignments.clear();
    filteredUsers.forEach((fu) => this.assignments.push(fu));
    this.popover?.close();
  }

  handleCancel() {
    const userFormArray = this.assignments;
    this.selectedUserIds = userFormArray.controls.map(
      (u) => u.get('id')?.value,
    );
    this.closePopover();
  }

  closePopover() {
    if (this.popover) {
      this.popover.close();
    }
  }

  selectPopover(p: NgbPopover) {
    this.popoverChangeSelection.emit(p);
  }
}
